import React, { Fragment, useContext } from "react";
import { DownloadContext } from "../../../context/DownloadContextProvider";
import { HamburgerContext } from "../../../context/HamburgerContextProvider";
import MobileAbout from "../../../parts/DropDown/MobileAbout/MobileAbout";
import Footer from "../../../parts/Footer/Footer";
import NavbarContainer from "../../../parts/Navbar/NavbarContainer";
import BuyAndSell from "../../Home/BuyAndSell/BuyAndSell";
import RegistrationForm from "../../Home/PopUpWindow/RegistrationForm/RegistrationForm";
import { Helmet } from "react-helmet";


import { useNavigate } from "react-router-dom";
import { BookingFlowParaContext } from "../../../context/BookingFlowParaProvider";

import NammaDriverTable from "./NammaDriverTable/NammaDriverTable";
import NammaDriverWhyDriveUDriverService from "./NammaDriverWhyDriveUDriverService/NammaDriverWhyDriveUDriverService";


function NammaDriver() {
  const navigate = useNavigate();
  const { showMediaIcons, handleFalse } = useContext(HamburgerContext);
  const { showPopUp, setShowPopUp } = useContext(DownloadContext);
  const { isAuthenticated } = useContext(BookingFlowParaContext);
  const hideHamburger = () => {
    handleFalse();
  };
  const handleBookDriver = () => {
    if (isAuthenticated === true) {
      navigate("/book-driver/");
    } else if (isAuthenticated === false) {
      setShowPopUp(true);
    }
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Compare with DriveU for hiring professional car drivers online
        </title>
        <meta
          name="description"
          content="Features that set DriveU apart - Affordable hourly charges, insurance, real-time driver tracking, and uniformed drivers."
        />
        <meta
          name="keywords"
          content="car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune car driver services, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune for hire, car driver services in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers for rent in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver service in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver agency Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune for rent, driver agency in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver service Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune car drivers services, hire a car driver in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, hire car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, book car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune"
        />
      </Helmet>
      <NavbarContainer />
      <div
        style={{ display: showMediaIcons ? "" : "none" }}
        className="MobileView_Option"
      >
        <MobileAbout />
      </div>
      <div onClick={hideHamburger}>
        <Fragment>
          <div className="container">
            <div className="wrapper-content-lottie">
              <div className="wrapper-content">
                <div className="content_hire">
                  <div className="content_subsection">
                    PROFESSIONAL&nbsp;CAR&nbsp;DRIVER&nbsp;SERVICE
                  </div>
                  <div className="content_section_heading">
                    NammaDriver vs DriveU
                  </div>
                  <div className="content_subsection_heading">
                    Affordable hourly charges, insurance, real-time driver
                    tracking, and uniformed drivers is what sets DriveU apart
                    from the competition.
                  </div>
                  <div className="btn_download_bookDriver">
                    <button onClick={handleBookDriver} className="book_driver">
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
              <div className="wrapper-lottie">
                <div
                  style={{
                    width: "100%",
                    marginLeft: "-5px",
                  }}
                  className="content_lottie"
                  id="content_lottie"
                >
                  <img
                    style={{ width: "100%" }}
                    src="https://ik.imagekit.io/driveu/Web/Hire4drive_vs_DriveU_rIBiZXr7M.png"
                    alt="SellCar"
                  />
                </div>
                <div className="btn-app-download-mobile">
                  <button
                    className="book_now_mobile"
                    onClick={handleBookDriver}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          {showPopUp ? <div className="overlay" /> : null}
          {showPopUp ? <RegistrationForm className="form_number" /> : null}
        </Fragment>
        <div
          style={{
            width: "100%",
            margin: "auto",
            maxWidth: "90em",
          }}
        >
          <NammaDriverTable />
          <NammaDriverWhyDriveUDriverService />
          {/* <CallDriversReview /> */}
        </div>
        <BuyAndSell />
        <Footer />
      </div>
    </div>
  );
}

export default NammaDriver;
